
import Vue from "vue";
import { InboxreaderService } from "@/services/inboxreader-service";
import { InboxreaderLabel } from "@/utils/purchase/inboxreader-label";
import AppColorPicker from "@/components/ColorPicker.vue";
import { getLabelTextColor } from "@/utils/inbox/label-color";

export default Vue.extend({
	data(){
		return {
			rows: [] as InboxreaderLabel[],
			newLabel: new InboxreaderLabel(),
			editingId: 0,
			editBackup: { Name: "", Color: "" },
			busy: false
		};
	},
	computed: {
		editingRow():InboxreaderLabel | undefined {
			return this.rows.find(r=>r.ID === this.editingId);
		}
	},
	methods: {
		async reload(){
			let labels = await InboxreaderService.getLabels();
			this.rows = labels.map(l=>new InboxreaderLabel(l.getJSON()));
		},
		textColor(color:string):string{
			return getLabelTextColor(color);
		},
		startEdit(row:InboxreaderLabel){
			this.editBackup = { Name: row.Name, Color: row.Color };
			this.editingId = row.ID;
		},
		cancelEdit(row:InboxreaderLabel){
			row.Name = this.editBackup.Name;
			row.Color = this.editBackup.Color;
			this.editingId = 0;
		},
		async saveRow(row:InboxreaderLabel){
			if (this.busy || !row.Name.trim()) return;
			try{
				this.busy = true;
				await InboxreaderService.updateLabel(row.ID, row.Name.trim(), row.Color);
				this.editingId = 0;
				this.$emit("updated");
			}finally{
				this.busy = false;
			}
		},
		async deleteRow(row:InboxreaderLabel){
			let confirm = await this.$wf.confirm(
				this.$ct("delete-label-confirm"),
				this.$ct("common.yes"),
				this.$ct("common.no"),
				this.$ct("common.warning"),
				"warning"
			);
			if (!confirm) return;
			try{
				this.busy = true;
				await InboxreaderService.deleteLabel(row.ID);
				this.editingId = 0;
				await this.reload();
				this.$emit("updated");
			}finally{
				this.busy = false;
			}
		},
		async addLabel(){
			if (this.busy || !this.newLabel.Name.trim()) return;
			try{
				this.busy = true;
				await InboxreaderService.createLabel(this.newLabel.Name.trim(), this.newLabel.Color);
				this.newLabel = new InboxreaderLabel();
				await this.reload();
				this.$emit("updated");
			}finally{
				this.busy = false;
			}
		},
		close(){
			this.$emit("close");
		}
	},
	async mounted(){
		await this.reload();
	},
	components: { AppColorPicker },
	i18nEx: {
		componentPrefix: "components.winbox"
	}
});
